<template>
  <div id="searchapp">
    <center>
      <img src="./assets/INT-logo.png" alt="INT" width="15%"/>
    </center>
      <br><br>


      <!-- SIMPLE SEARCH - USER INPUT -->

      <b-container v-if="selectedSearchType=='simple_search'">

        <b-row>          
          <b-col cols="auto">
            <b-form-group>Zoekmodus:
              <b-form-radio-group v-model="selectedSearchType" 
                buttons 
                button-variant="outline-success" size="sm"                
                name="search_check_buttons"
                :options="searchType">
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col cols="auto">           
          </b-col>

          <b-col cols="auto">
            <b-form-group>
              Zoeken in:
              <b-form-checkbox-group buttons button-variant="outline-success" size="sm" v-model="simpleActiveSets" :options="[{text: 'ANW', value: 'anw'}]">
               </b-form-checkbox-group>
              <b-form-checkbox-group buttons button-variant="outline-success" size="sm" v-model="simpleActiveSets" :options="[{text: 'Celex', value: 'celex'}]">
               </b-form-checkbox-group>
              <b-form-checkbox-group buttons button-variant="outline-success" size="sm" v-model="simpleActiveSets" :options="[{text: 'DuelMe', value: 'duelme'}]">
               </b-form-checkbox-group>
              <b-form-checkbox-group buttons button-variant="outline-success" size="sm" v-model="simpleActiveSets" :options="[{text: 'Molex', value: 'molex'}]">
               </b-form-checkbox-group>
            </b-form-group>
          </b-col>

        </b-row>    

        <br> 

        <b-row>
          <b-col xs="auto">
            <b-form-input v-model="searchQuery" @keydown.native="startSearchWithEnter" id="simple_search_field" type="text" placeholder="Tik hier een zoekopdracht... (reguliere expressies toegestaan)">
            </b-form-input>
            <b-tooltip target="simple_search_field" v-if="simpleSearch_RegexFound" :show.sync="simpleSearch_RegexFound">Uw zoekopdracht bevat een reguliere expressie. Het kan het zoeken flink vertragen</b-tooltip>
          </b-col>
          <b-col cols="auto">
            <b-btn @click="startSearch" size="lg" variant="primary">Zoeken</b-btn>
          </b-col>
          <b-col cols="auto">
            <b-btn @click="searchQuery=''" :disabled="searchQuery==''" size="lg" variant="success">Wissen</b-btn>
          </b-col>
        </b-row>  

      </b-container>


      <!-- ADVANCED SEARCH - USER INPUT -->

       <b-container v-if="selectedSearchType=='advanced_search'">

         <b-row>          
          <b-col cols="auto">
            <b-form-group>Zoekmodus:
              <b-form-radio-group v-model="selectedSearchType" 
                buttons 
                button-variant="outline-success" size="sm"                
                name="search_check_buttons"
                :options="searchType">
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col cols="auto">    
          </b-col>

          <b-col cols="auto">
            <b-form-group>
              Zoeken in:
              <b-form-checkbox-group buttons button-variant="outline-success" size="sm" v-model="advancedActiveSets" :options="[{text: 'ANW', value: 'anw'}]">
               </b-form-checkbox-group>
              <b-form-checkbox-group buttons button-variant="outline-success" size="sm" v-model="advancedActiveSets" :options="[{text: 'Celex', value: 'celex'}]">
               </b-form-checkbox-group>
              <b-form-checkbox-group buttons button-variant="outline-success" size="sm" v-model="advancedActiveSets" :options="[{text: 'DuelMe', value: 'duelme'}]">
               </b-form-checkbox-group>
              <b-form-checkbox-group buttons button-variant="outline-success" size="sm" v-model="advancedActiveSets" :options="[{text: 'Molex', value: 'molex'}]">
               </b-form-checkbox-group>
            </b-form-group>
          </b-col>

          <b-col cols="auto">    
          </b-col>          

        </b-row>      

      <br>
       
        <table>

          <tr>            
            <td>
              Lemma
            </td>
            <td>
              <b-form-input v-model="advancedLemma" @keydown.native="startSearchWithEnter" type="text" :disabled="false" id="advanced_search_lemmafield">
              </b-form-input>
              <b-tooltip target="advanced_search_lemmafield" v-if="advancedLemma_regexFound" :show.sync="advancedLemma_regexFound">Uw zoekopdracht bevat een reguliere expressie. Het kan het zoeken flink vertragen</b-tooltip>
            </td>            

            <td class="separator">             
            </td>
          
            <td>
              Woordvorm
            </td>
            <td>
              <b-form-input v-model="advancedWordform" @keydown.native="startSearchWithEnter" type="text" :disabled="advancedActiveSets.indexOf('celex')<0 && advancedActiveSets.indexOf('molex')<0" id="advanced_search_wordformfield">                
              </b-form-input>  
              <b-tooltip target="advanced_search_wordformfield" v-if="advancedWordform_regexFound" :show.sync="advancedWordform_regexFound">Uw zoekopdracht bevat een reguliere expressie. Het kan het zoeken flink vertragen</b-tooltip>
            </td>
            <td class="separator">             
            </td>

            <td>
              Geslacht
            </td>
            <td>
              <b-form-input v-model="advancedGender" @keydown.native="startSearchWithEnter" type="text"  :disabled="advancedActiveSets.indexOf('duelme')<0 && advancedActiveSets.indexOf('celex')<0 && advancedActiveSets.indexOf('molex')<0" id="advanced_search_genderfield">
              </b-form-input>
              <b-tooltip target="advanced_search_genderfield" v-if="advancedGenderBadInputFound" :show.sync="advancedGenderBadInputFound">In dit veld zijn de toegestane waarden: Com, Masc, Fem, Neut</b-tooltip>
            </td>

            <td class="separator">             
            </td>
            <td>              
            </td>
            <td class="separator">             
            </td>
            <td>
            </td>

          </tr>
        
          <tr>            
            <td>
              Lemma POS
            </td>
            <td>
              <b-form-input v-model="advancedLemPos" @keydown.native="startSearchWithEnter" type="text"  :disabled="advancedActiveSets.indexOf('celex')<0 && advancedActiveSets.indexOf('molex')<0 && advancedActiveSets.indexOf('duelmemwe')<0" id="advanced_search_lemposfield">
              </b-form-input>
              <b-tooltip target="advanced_search_lemposfield" v-if="advancedLemPosBadInputFound" :show.sync="advancedLemPosBadInputFound">In dit veld zijn de toegestane waarden: ADJ, ADP, ADV, AP, CCONJ, DET, NOUN, NP, PP, PRON, SCONJ, VERB, VP</b-tooltip>
            </td>
           

            <td class="separator">             
            </td>
            
            <td>
              Woordvorm POS
            </td>
            <td>
              <b-form-input v-model="advancedWordformPos" @keydown.native="startSearchWithEnter" type="text" :disabled="advancedActiveSets.indexOf('celex')<0 && advancedActiveSets.indexOf('molex')<0" id="advanced_search_wfposfield">
              </b-form-input>
              <b-tooltip target="advanced_search_wfposfield" v-if="advancedWfPosBadInputFound" :show.sync="advancedWfPosBadInputFound">In dit veld zijn de toegestane waarden: ADJ, ADP, ADV, AP, CCONJ, DET, NOUN, NP, PP, PRON, SCONJ, VERB, VP</b-tooltip>
            </td>

            <td class="separator">             
            </td>

            <td>
              Getal
            </td>
            <td>
              <b-form-input v-model="advancedNumber" @keydown.native="startSearchWithEnter" type="text"  :disabled="advancedActiveSets.indexOf('duelme')<0 && advancedActiveSets.indexOf('celex')<0 && advancedActiveSets.indexOf('molex')<0" id="advanced_search_numberfield">
              </b-form-input>
              <b-tooltip target="advanced_search_numberfield" v-if="advancedNumberBadInputFound" :show.sync="advancedNumberBadInputFound">In dit veld zijn de toegestane waarden: Sing, Plur</b-tooltip>
            </td>

            <td class="separator">             
            </td>
            <td>              
            </td>
            <td class="separator">             
            </td>
            <td>
            </td>

          </tr>


           <tr>            
            <td>
              Definitie
            </td>
            <td>
              <b-form-input v-model="advancedDefinition" @keydown.native="startSearchWithEnter" type="text"  :disabled="advancedActiveSets.indexOf('anw')<0">
              </b-form-input>
            </td>

            <td class="separator">             
            </td>
            
            <td>
              Definitie Syn
            </td>
            <td>
              <b-form-input v-model="advancedSynDefinition" @keydown.native="startSearchWithEnter" type="text"  :disabled="true">
              </b-form-input>
            </td> 

            <td class="separator">             
            </td>

            <td>             
            </td>
            <td>             
            </td>

            <td class="separator">             
            </td>
            <td>              
            </td>
            <td class="separator">             
            </td>
            <td>
            </td>

          </tr>

          <tr>            
            <td>
              Voorbeeld
            </td>
            <td>
              <b-form-input v-model="advancedExample" @keydown.native="startSearchWithEnter" type="text"  :disabled="advancedActiveSets.indexOf('duelme')<0">
              </b-form-input>
            </td>

            <td class="separator">             
            </td>
            
            <td>
              Attestatie
            </td>
            <td>
              <b-form-input v-model="advancedAttestation" @keydown.native="startSearchWithEnter" type="text"  :disabled="advancedActiveSets.indexOf('duelme')<0">
              </b-form-input>
            </td> 

            <td class="separator">             
            </td>

            <td>
              
            </td>
            <td>
              
            </td>

            <td class="separator">             
            </td>
            <td>
              <b-btn @click="startSearch" size="lg" variant="primary">Zoeken</b-btn>
            </td>
            <td class="separator">             
            </td>
            <td>
              <b-btn @click="resetAdvancedSearchFields" :disabled="advancedFieldsAreAllEmpty" size="lg" variant="success">Wissen</b-btn>
            </td>

          </tr>

        </table>
        

      </b-container>


      <!-- EXPERT SEARCH - USER INPUT -->

      <b-container v-if="selectedSearchType=='expert_search'">

        <b-row>          
          <b-col cols="auto">
            <b-form-group>ZoekModus:
              <b-form-radio-group v-model="selectedSearchType" 
                buttons 
                button-variant="outline-success" size="sm"                
                name="search_check_buttons"
                :options="searchType">
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col cols="auto">           
          </b-col>

          <b-col md="auto">
            Vul in:
          </b-col>
          <b-col md="auto">
            <b-form-input v-model="searchQuery" type="text" placeholder="Zoekterm...">
            </b-form-input>
          </b-col>

          <b-col md="auto">
            en kies:
          </b-col>
          <b-col md="auto">
            <b-form-select v-model="expertChosenQuery" :options="expertQueryOptions">
            </b-form-select >
          </b-col>
          
          
        </b-row>    

        <br>         

        <b-row>                 
          <b-col xs="auto">
            <!-- SPARQL QUERY EDITOR CONSTRUCTOR -->
            <code-mirror :code="sparqlQuery" id="sparqlQueryTextarea" @editor_input="updateSparqlQuery"></code-mirror>           
          </b-col>
          <b-col cols="auto">
            <b-btn @click="startSearch" size="lg" variant="primary">Zoeken</b-btn>
          </b-col>
          <b-col cols="auto">
            <b-btn 
            @click="sparqlQuery=basisSparqlQuery; searchQuery=''; expertChosenQuery=null" 
            :disabled="sparqlQuery==basisSparqlQuery&&searchQuery==''&&expertChosenQuery==null" 
            size="lg" variant="success">Wissen</b-btn>
          </b-col>
        </b-row>  

      </b-container>

      <!-- ERROR MSG -->

      <div>
        <b-modal v-model="showErrorMsg" ref="errorModal" title="Er is een fout opgetreden"><p class="blackmsg">{{errorLocation}}</p><p class="redmsg">{{errorMsg}}</p></b-modal>
      </div>


      <!-- RESULTS CONSTRUCTORS -->
      
      <!-- SIMPLE SEARCH - RESULTS -->

      <b-container v-if="selectedSearchType=='simple_search'">

        <div id="tabs" class="container">

            <!-- tabs -->
            <div class="tabs">
                <a v-show="simpleActiveSets.indexOf('anw')>-1" v-on:click="simpleActiveTab='anw'" v-bind:class="[ simpleActiveTab === 'anw' ? 'active' : '' ]"><div v-if="searching['simple_search_anw']">ANW (bezig...)</div><div v-else>ANW ({{items['simple_search_anw'].length}})</div></a>
                <a v-show="simpleActiveSets.indexOf('celex')>-1" v-on:click="simpleActiveTab='celex'" v-bind:class="[ simpleActiveTab === 'celex' ? 'active' : '' ]"><div v-if="searching['simple_search_celex']">Celex (bezig...)</div><div v-else>Celex ({{items['simple_search_celex'].length}})</div></a>
                <a v-show="simpleActiveSets.indexOf('duelme')>-1" v-on:click="simpleActiveTab='duelme'" v-bind:class="[ simpleActiveTab === 'duelme' ? 'active' : '' ]"><div v-if="searching['simple_search_duelme']">DuelMe (bezig...)</div><div v-else>DuelMe ({{items['simple_search_duelme'].length}})</div></a>
                <a v-show="simpleActiveSets.indexOf('molex')>-1" v-on:click="simpleActiveTab='molex'" v-bind:class="[ simpleActiveTab === 'molex' ? 'active' : '' ]"><div v-if="searching['simple_search_molex']">Molex (bezig...)</div><div v-else>Molex ({{items['simple_search_molex'].length}})</div></a>                
            </div>

            <!-- tabs content -->
            <div class="content">

                <!-- ANW -->
                <div v-show="simpleActiveTab === 'anw'" class="tabcontent">
                    <div style="height: 50px">
                        <!-- progress bar -->
                        <img v-show="searching['simple_search_anw']" src="./assets/index.sandglass-time-loading-gif.gif" height="50px">                        
                    </div>
                    <!-- table with results -->
                    <data-table :sortBy="sortBy['simple_search_anw']" :sortDesc="sortDesc['simple_search_anw']" :searching="searching['simple_search_anw']" :items="items['simple_search_anw']" :fields="fields['simple_search_anw']"></data-table>
                </div>

                <!-- Celex -->
                <div v-show="simpleActiveTab === 'celex'" class="tabcontent">
                    <div style="height: 50px">
                        <!-- progress bar -->
                        <img v-show="searching['simple_search_celex']" src="./assets/index.sandglass-time-loading-gif.gif" height="50px">
                    </div>
                    <!-- table with results -->
                    <data-table :sortBy="sortBy['simple_search_celex']" :sortDesc="sortDesc['simple_search_celex']" :searching="searching['simple_search_celex']" :items="items['simple_search_celex']" :fields="fields['simple_search_celex']"></data-table>
                </div>

                <!-- DuelMe -->
                <div v-show="simpleActiveTab === 'duelme'" class="tabcontent">
                    <div style="height: 50px">
                        <!-- progress bar -->
                        <img v-show="searching['simple_search_duelme']" src="./assets/index.sandglass-time-loading-gif.gif" height="50px">
                    </div>
                    <!-- table with results -->
                    <data-table :sortBy="sortBy['simple_search_duelme']" :sortDesc="sortDesc['simple_search_duelme']" :searching="searching['simple_search_duelme']" :items="items['simple_search_duelme']" :fields="fields['simple_search_duelme']"></data-table>
                </div>

                <!-- Molex -->
                <div v-show="simpleActiveTab === 'molex'" class="tabcontent">
                    <div style="height: 50px">
                        <!-- progress bar -->
                        <img v-show="searching['simple_search_molex']" src="./assets/index.sandglass-time-loading-gif.gif" height="50px">
                    </div>
                    <!-- table with results -->
                    <data-table :sortBy="sortBy['simple_search_molex']" :sortDesc="sortDesc['simple_search_molex']" :searching="searching['simple_search_molex']" :items="items['simple_search_molex']" :fields="fields['simple_search_molex']"></data-table>
                </div>

            </div>

        </div>

      </b-container>

      <!-- ADVANCED SEARCH - RESULTS -->

      <b-container v-if="selectedSearchType=='advanced_search'">

        <div id="tabs" class="container">

          <!-- tab -->
          <div class="tabs">
            <a v-on:click="advancedActiveTab='advanced_search_definition'" v-bind:class="[ advancedActiveTab === 'advanced_search_definition' ? 'active' : '' ]">
              <div v-if="searching['advanced_search_definition']">Definities (bezig...)</div><div v-else>Definities ({{items['advanced_search_definition'].length}})</div>
            </a>
            <a v-on:click="advancedActiveTab='advanced_search_paradigm'" v-bind:class="[ advancedActiveTab === 'advanced_search_paradigm' ? 'active' : '' ]">
              <div v-if="searching['advanced_search_paradigm']">Paradigmata (bezig...)</div><div v-else>Paradigmata ({{items['advanced_search_paradigm'].length == this.paradigmLimit ? 'First '+this.paradigmLimit : items['advanced_search_paradigm'].length }})</div>
            </a>
            <a v-on:click="advancedActiveTab='advanced_search_attestations'" v-bind:class="[ advancedActiveTab === 'advanced_search_attestations' ? 'active' : '' ]">
              <div v-if="searching['advanced_search_attestations']">Attestaties (bezig...)</div><div v-else>Attestaties ({{items['advanced_search_attestations'].length}})</div>
            </a>
            <a v-on:click="advancedActiveTab='advanced_search_mwe'" v-bind:class="[ advancedActiveTab === 'advanced_search_mwe' ? 'active' : '' ]">
              <div v-if="searching['advanced_search_mwe']">Verbindingen (bezig...)</div><div v-else>Verbindingen ({{items['advanced_search_mwe'].length}})</div>
            </a>
          </div>

          <div v-show="advancedActiveTab === 'advanced_search_definition'" class="tabcontent">
            <div style="height: 50px">
                <!-- progress bar -->
                <img v-show="searching['advanced_search_definition']" src="./assets/index.sandglass-time-loading-gif.gif" height="50px">
            </div>
            <!-- definition results -->
            <data-table :sortBy="sortBy['advanced_search_definition']" :sortDesc="sortDesc['advanced_search_definition']" :searching="searching['advanced_search_definition']" :items="items['advanced_search_definition']" :fields="fields['advanced_search_definition']"></data-table>          
          </div>

          <!-- tab content -->
          <div v-show="advancedActiveTab === 'advanced_search_paradigm'" class="tabcontent">
            <div style="height: 50px">
                <!-- progress bar -->
                <img v-show="searching['advanced_search_paradigm']" src="./assets/index.sandglass-time-loading-gif.gif" height="50px">
            </div>
            <!-- paradigm results -->
            <data-table :sortBy="sortBy['advanced_search_paradigm']" :sortDesc="sortDesc['advanced_search_paradigm']" :searching="searching['advanced_search_paradigm']" :items="items['advanced_search_paradigm']" :fields="fields['advanced_search_paradigm']"></data-table>
          </div>

           <!-- tab content -->
          <div v-show="advancedActiveTab === 'advanced_search_attestations'" class="tabcontent">
            <div style="height: 50px">
                <!-- progress bar -->
                <img v-show="searching['advanced_search_attestations']" src="./assets/index.sandglass-time-loading-gif.gif" height="50px">
            </div>
            <!-- paradigm results -->
            <data-table :sortBy="sortBy['advanced_search_attestations']" :sortDesc="sortDesc['advanced_search_attestations']" :searching="searching['advanced_search_attestations']" :items="items['advanced_search_attestations']" :fields="fields['advanced_search_attestations']"></data-table>
          </div>


          <!-- tab content -->
          <div v-show="advancedActiveTab === 'advanced_search_mwe'" class="tabcontent">
            <div style="height: 50px">
                <!-- progress bar -->
                <img v-show="searching['advanced_search_mwe']" src="./assets/index.sandglass-time-loading-gif.gif" height="50px">
            </div>
            <!-- paradigm results -->
            <data-table :sortBy="sortBy['advanced_search_mwe']" :sortDesc="sortDesc['advanced_search_mwe']" :searching="searching['advanced_search_mwe']" :items="items['advanced_search_mwe']" :fields="fields['advanced_search_mwe']"></data-table>
          </div>

        </div>

      </b-container>


      <!-- EXPERT SEARCH - RESULTS -->

      <b-container v-if="selectedSearchType=='expert_search'">

        <div id="tabs" class="container">

          <!-- tab -->
          <div class="tabs">
                  <a><div v-if="searching['expert_search']">Expert (bezig...)</div><div v-else>Expert ({{items['expert_search'].length}})</div></a>
          </div>

          <!-- tab content -->
          <div class="tabcontent">
            <div style="height: 50px">
                <!-- progress bar -->
                <img v-show="searching['expert_search']" src="./assets/index.sandglass-time-loading-gif.gif" height="50px">
            </div>

            <!-- table with results -->
            <data-table :sortBy="sortBy['expert_search']" :sortDesc="sortDesc['expert_search']" :searching="searching['expert_search']" :items="items['expert_search']" :fields="fields['expert_search']"></data-table>
          </div>

        </div>
        
      </b-container>
    
  </div>
</template>


<script>

// components
import Vue from 'vue';
import DataTable from './components/DataTable.vue';
import QueryEditor from './components/QueryEditor.vue';
import bModal from 'bootstrap-vue/es/components/modal/modal';
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal';

// js help functions
import * as parser from './js/parser.js';
import * as utils from './js/utils.js';
import * as tableBuilder from './js/tableBuilder.js';
import * as simpleQueryBuilder from './js/simpleQueryBuilder.js';
import * as complexQueryBuilder from './js/complexQueryBuilder.js';
import { isDate } from 'util';




export default {
  name: 'searchapp',
  components: {
    'data-table': DataTable,
    'code-mirror': QueryEditor,
    
  },
  data () {    // data is internal state of component
    return {

      // ----- COMMON Search form variables -----------------------------


      debug: false, // set to true when one needs to debug

      paradigmLimit: 10000,

      endpoint: {
        'default': 'http://rdf.ivdnt.org/sparql', //'http://172.16.4.56:8890/sparql',
        'diamant': 'http://svprre02:8080/fuseki/tdb/sparql'
      },

      keyword: {'main': ''},
      errorMsg: '',
      errorLocation: '',

      selectedSearchType: 'simple_search', // default!
      searchType: [
        { value: 'simple_search', text: 'Eenvoudig' },
        { value: 'advanced_search', text: 'Gecombineerd' },
        { value: 'expert_search', text: 'Expert' }
      ],
      
      // ----- SIMPLE Search form variables -----------------------------

      searchQuery: '',  
      simpleActiveTab: 'anw', // default    
      simpleActiveSets: [ 'anw', 
                          'celex', 
                          'duelme', 
                          'molex'
                          ], 

      // ----- ADVANCED Search variables -----------------------------
      
      advancedActiveTab: 'advanced_search_definition', // default
      advancedActiveSets: [ 'anw', 
                            'celex',
                            'duelme', 
                            'duelmemwe', 
                            'molex'
                            ], 
      advancedActiveSetsGroups: {
        "definition": ['anw'],
        "paradigm": ['celex', 'molex'],
        "attestations": ['duelme'],
        "mwe": ['duelmemwe']
      },      


      // search term per field
      advancedLemma: '',
      advancedWordform: '',
      advancedLemPos: '',
      advancedWordformPos: '',
	    advancedDefinition: '',
      advancedSynDefinition: '',
      advancedExample: '',
      advancedAttestation: '',
      advancedNumber: '',
      advancedGender: '',

      // ----- EXPERT Search variables  -----------------------------

      expertChosenQuery: null,     
      expertQueryOptions: [
        { value: null, text: "Basis query" },
        { value: "anw", text: 'ANW query' },
        { value: "celex", text: 'Celex query' },
        { value: "duelme", text: 'DuelMe query' },
        { value: "molex", text: 'GiGaNT MoLex query' }
      ],
      sparqlQuery: 'PREFIX ontolex: <http://www.w3.org/ns/lemon/ontolex#>\n'+
        'PREFIX anw: <http://rdf.ivdnt.org/lexica/anw>\n'+
        'PREFIX lemon: <http://lemon-model.net/lemon#>\n'+
        'SELECT ?sub ?pred ?obj \n'+
        'WHERE {\n'+
        '  ?sub ?pred ?obj .'+
        '}\n'+
        'LIMIT 10',
      basisSparqlQuery: 'PREFIX ontolex: <http://www.w3.org/ns/lemon/ontolex#>\n'+
        'PREFIX anw: <http://rdf.ivdnt.org/lexica/anw>\n'+
        'PREFIX lemon: <http://lemon-model.net/lemon#>\n'+
        'SELECT ?sub ?pred ?obj \n'+
        'WHERE {\n'+
        '  ?sub ?pred ?obj .'+
        '}\n'+
        'LIMIT 10',

      // ----- Results component variables  -----------------------------

      fields: {
        'simple_search_anw': [], 'simple_search_celex': [], 'simple_search_duelme': [], 'simple_search_molex': [], 
        'advanced_search_definition': [], 'advanced_search_paradigm': [], 'advanced_search_attestations': [], 'advanced_search_mwe': [],
        'expert_search': [] },   // fields to be shown 
      items: {
        'simple_search_anw': [], 'simple_search_celex': [], 'simple_search_duelme': [], 'simple_search_molex': [],      
        'advanced_search_definition': [], 'advanced_search_paradigm': [], 'advanced_search_attestations': [], 'advanced_search_mwe': [],
        'expert_search': [] },    // table content      
      sortBy: {
        'simple_search_anw': '', 'simple_search_celex': '', 'simple_search_duelme': '', 'simple_search_molex': '',
        'advanced_search_definition': '', 'advanced_search_paradigm': '', 'advanced_search_attestations': '', 'advanced_search_mwe': '',
        'expert_search': '' },     // sort options
      sortDesc: {
        'simple_search_anw': true, 'simple_search_celex': true, 'simple_search_duelme': true, 'simple_search_molex': true,
        'advanced_search_definition': true, 'advanced_search_paradigm': true, 'advanced_search_attestations': true, 'advanced_search_mwe': true,
        'expert_search': true },   // ascending: true, descending: false
      searching: { 
        'simple_search_anw': false, 'simple_search_celex': false, 'simple_search_duelme': false, 'simple_search_molex': false,
        'advanced_search_definition': false, 'advanced_search_paradigm': false, 'advanced_search_attestations': false, 'advanced_search_mwe': false,
        'expert_search': false }   // status: search is busy (true) or done (false)
    }
  },

  computed: {
    
    advancedFieldsAreAllEmpty: {
      get: function(){
        return  this.advancedLemma=='' &&
                this.advancedWordform=='' &&
                this.advancedLemPos=='' &&
                this.advancedWordformPos=='' &&
                this.advancedDefinition=='' &&
                this.advancedSynDefinition=='' &&
                this.advancedExample=='' &&
                this.advancedAttestation=='' &&
                this.advancedNumber=='' &&
                this.advancedGender=='';
      },
      set: function(){
        // no needed yet
      }
    },

    // if we have an error, is must be shown!
    showErrorMsg: {      
      get: function(){
        return (this.errorMsg != ''); // true if non-empty
      },
      set: function(){
        // no needed yet
      }
      
    },

    selectFieldsOfAdvancedDefinitionSearch: {

      get: function(){
        var anwActive = this.advancedActiveSets.indexOf('anw')>=0;

        return {     
          'anwLemma': anwActive,
          'writtenForm': anwActive,
          'anwDefinition': anwActive,

          'diamantLemma': false,
          'diamantDefinition': false,
          'diamantSynDefinition': false
        }
      },
      set: function(){
        // no needed yet
      }
    },

    selectFieldsOfAdvancedParadigmSearch: {

      get: function(){
        var celexActive = this.advancedActiveSets.indexOf('celex')>=0;        
        var molexActive = this.advancedActiveSets.indexOf('molex')>=0;        

        return {              
          'celexLemma': celexActive,
          'celexSublemmata': celexActive,
          'celexWordform': celexActive,          
          'celexGender': celexActive,
          'celexNumber': celexActive, 
          'celexMorph': celexActive, 
          'celexPronunciation': celexActive, 
          
          'molexLemma': molexActive, 
          'molexLemPos': molexActive, 
          'molexWordform': molexActive, 
          'molexHyphenation': molexActive, 
          'molexWordformPos': molexActive, 
          'molexGender': molexActive, 
          'molexNumber': molexActive
        }
      },
      set: function(){
        // no needed yet
      }
    },

    selectFieldsOfAdvancedAttestationSearch: {
      get: function(){
        
        var duelMeActive = this.advancedActiveSets.indexOf('duelme')>=0;        

        return {
          'duelMeLemma': duelMeActive,
          'duelMeGender': duelMeActive,
          'duelMeExample': duelMeActive,
          'duelMeAttestation': duelMeActive,
          'duelMeNumber': duelMeActive
        }
      },
      set: function(){
        // no needed yet
      }
    },

    selectFieldsOfAdvancedMweSearch: {

      get: function(){
        
        var duelMeMweActive = this.advancedActiveSets.indexOf('duelme')>=0;        

        return {
          'duelMeMweLemma': duelMeMweActive,
          'duelMeMwePos': duelMeMweActive
        }
      },
      set: function(){
        // no needed yet
      }

    },

    simpleSearch_RegexFound: {
      get: function(){
        return utils.containsRegex(this.searchQuery);
      },
      set: function(){
        // not needed yet
      }
    },
    advancedLemPosBadInputFound: {
      get: function(){
        return ['', 'ADJ', 'ADP', 'ADV', 'CCONJ', 'DET', 'NOUN', 'PRON', 'SCONJ', 'VERB'].indexOf(this.advancedLemPos)<0;
      },
      set: function(){
        // not needed yet
      }
    },
    advancedWfPosBadInputFound: {
      get: function(){
        return ['', 'ADJ', 'ADP', 'ADV', 'CCONJ', 'DET', 'NOUN', 'PRON', 'SCONJ', 'VERB'].indexOf(this.advancedWordformPos)<0;
      },
      set: function(){
        // not needed yet
      }
    },
    advancedNumberBadInputFound: {
      get: function(){
        return ['', 'Sing', 'Plur'].indexOf(this.advancedNumber)<0;
      },
      set: function(){
        // not needed yet
      }
    },
    advancedGenderBadInputFound: {
      get: function(){
        return ['', 'Com', 'Neut'].indexOf(this.advancedGender)<0;
      },
      set: function(){
        // not needed yet
      }
    },
    advancedLemma_regexFound: {
      get: function(){
        return utils.containsRegex(this.advancedLemma);
      },
      set: function(){
        // not needed yet
      }
    },
    advancedWordform_regexFound: {
      get: function(){
        return utils.containsRegex(this.advancedWordform);
      },
      set: function(){
        // not needed yet
      }
    }
  
  },

  watch: {

    advancedActiveSets: function(){

        // special case: in advanced search, we have to add 'duelmemwe' to the active sets if 'duelme' is active too.
        // this is because we have only one button to activate duelme, whereas the app logic processes 2 different duelme sets
        // (t.i. one in attestations and one in mwe)
        if (this.advancedActiveSets.indexOf("duelme")>=0 && this.advancedActiveSets.indexOf("duelmemwe")<0)
          this.advancedActiveSets.push("duelmemwe");
        // when duelme is unchecked, we have to remove duelmemwe as well...
        else if (this.advancedActiveSets.indexOf("duelme")<0 && this.advancedActiveSets.indexOf("duelmemwe")>=0)
          this.advancedActiveSets.splice( this.advancedActiveSets.indexOf('duelmemwe'), 1 );
    },

    // needed for the Sparql query editor (codemirror):
    // build the sparql query as soon as a type is chosen

    expertChosenQuery: function(){
      if (this.expertChosenQuery == 'anw')
        this.sparqlQuery = utils.removeColorIdColumn( simpleQueryBuilder.buildAnwQuery(this.searchQuery) );
      else if (this.expertChosenQuery == 'celex')
        this.sparqlQuery = utils.removeColorIdColumn( simpleQueryBuilder.buildCelexQuery(this.searchQuery) );
      else if (this.expertChosenQuery == 'duelme')
        this.sparqlQuery = utils.removeColorIdColumn( simpleQueryBuilder.buildDuelMeQuery(this.searchQuery) );
      else if (this.expertChosenQuery == 'molex')
        this.sparqlQuery = utils.removeColorIdColumn( simpleQueryBuilder.buildMolexQuery(this.searchQuery) );
      else
        this.sparqlQuery = utils.removeColorIdColumn( this.basisSparqlQuery );
    },

    
    

  },

  methods: {

    show_debug_info: function(info){
      if (this.debug)
        console.log(info);
    },

    // -----------------------------------------------------------------

    // ADVANCED SEARCH help functions

    updateSparqlQuery: function(code){

      // update the sparql query, given the live input from the sparql editor

      this.sparqlQuery = code;
    },

    resetAdvancedSearchFields: function(){

      this.advancedLemma = '';
      this.advancedWordform = '';
      this.advancedLemPos = '';
      this.advancedWordformPos = '';
      this.advancedDefinition = '';
      this.advancedSynDefinition = '';
      this.advancedExample = '';
      this.advancedAttestation = '';
      this.advancedNumber = '';
      this.advancedGender = '';
    },
    

    // -----------------------------------------------------------------

    // MAIN SEARCH PART

    // Enable search with strike on 'Enter' key

    startSearchWithEnter: function(event){
      if (event.which === 13) {
        this.startSearch();
      }
    },


    // THE search function

    startSearch: function(){

      // matchers must be highlighted!

      // simple search
      this.keyword['main'] = this.searchQuery;

      // advanced search
      if (this.selectedSearchType == 'advanced_search')
      {

        this.keyword['anwLemma'] = this.advancedLemma;
        this.keyword['anwDefinition'] = this.advancedDefinition;        

        this.keyword['duelMeLemma'] = this.advancedLemma;
        this.keyword['duelMeExample'] = this.advancedExample;
        this.keyword['duelMeAttestation'] = this.advancedAttestation;
        this.keyword['celexNumber'] = this.advancedNumber;
        this.keyword['celexGender'] = this.advancedGender;

        this.keyword['duelMeMweLemma'] = this.advancedLemma;
        this.keyword['duelMeMwePos'] = this.advancedLemPos;

        this.keyword['duelMeNumber'] = this.advancedNumber;
        this.keyword['duelMeGender'] = this.advancedGender;
        this.keyword['celexLemma'] = this.advancedLemma;
        this.keyword['celexWordform'] = this.advancedWordform;

        this.keyword['diamantLemma'] = this.advancedLemma;
        this.keyword['diamantDefinition'] = this.advancedDefinition;
        this.keyword['diamantSynDefinition'] = this.advancedSynDefinition;

        this.keyword['molexLemma'] = this.advancedLemma;
        this.keyword['molexLemPos'] = this.advancedLemPos;
        this.keyword['molexWordform'] = this.advancedWordform;        
        this.keyword['molexWordformPos'] = this.advancedWordformPos;
      }

      // expert search
      if (this.selectedSearchType == 'expert_search')
      {
        this.keyword['main'] = '';
      }



      // get table settings/options
      // and fetch the data

      if (this.selectedSearchType == 'simple_search')
      {
        // integrity check
        if (this.simpleActiveSets.length == 0 )
        {
          this.errorMsg = "U moet minstens één dataset selecteren om in te zoeken";
          return;
        }

        // in SIMPLE SEARCH, we have to fire a separate search
        // for each active set
        for (var i=0; i<this.simpleActiveSets.length; i++)
        {
          var activeset = this.simpleActiveSets[i];
          var searchType_ActiveSet = this.selectedSearchType +'_'+ activeset;

          // hide error message from previous round, if any
          this.errorMsg = '';
          this.errorLocation = '';

          // set status: search has started
          //this.searching[searchType_ActiveSet] = true;

          // give table for results the right properties, given the query
          var tableOptions = tableBuilder.getOptions(null, this.keyword, this.selectedSearchType, null, activeset);

          this.fields[searchType_ActiveSet] = tableOptions["fields"];
          var sortSettings = tableOptions["sortsettings"];
          this.sortBy[searchType_ActiveSet] = sortSettings[0];
          this.sortDesc[searchType_ActiveSet] = sortSettings[1];

          // effectively start the search
          this.fetchData(this, activeset);
        }
      }


      else if (this.selectedSearchType == 'advanced_search') 
      {
        var thisObj = this;

        // integrity check
        var selectFieldsOfAdvancedSearch =  Object.assign({}, 
            thisObj.selectFieldsOfAdvancedDefinitionSearch, 
            thisObj.selectFieldsOfAdvancedParadigmSearch,
            thisObj.selectFieldsOfAdvancedAttestationSearch,
            thisObj.selectFieldsOfAdvancedMweSearch
            );
        if (typeof (utils.getKeyByValue(selectFieldsOfAdvancedSearch, true)) == 'undefined' )
        {
          thisObj.errorMsg = "U moet minstens één dataset selecteren om in te zoeken";
          return;
        }

        // in advanced search, we fire 4 different searches
        var advancedActiveSetsList = [
          "definition", 
          "paradigm", 
          "attestations",
          "mwe"];
        var advancedSearchFieldsSets = [
          thisObj.selectFieldsOfAdvancedDefinitionSearch, 
          thisObj.selectFieldsOfAdvancedParadigmSearch,
          thisObj.selectFieldsOfAdvancedAttestationSearch,
          thisObj.selectFieldsOfAdvancedMweSearch
          ];

        
        for (var i=0; i<advancedSearchFieldsSets.length; i++)
        {
          const activeAdvancedSearchFieldsSet = advancedSearchFieldsSets[i];
          const activeset = advancedActiveSetsList[i];
          const searchType_ActiveSet = "advanced_search_"+activeset;

          // hide error message from previous round, if any
          thisObj.errorMsg = '';
          thisObj.errorLocation = '';

          // We have to fire a separate search for each active set
          // So, first build an array of promises 

          var fetchDataPromises = [];

          // if the set is active (t.i. chosen in the GUI)
          // (that is: find if there is any intersection between active sets and sets in the current group)
          if (  ( (thisObj.advancedActiveSetsGroups[activeset]).filter(value => (thisObj.advancedActiveSets).includes(value)) ).length>0 )
            {
              // effectively plan the search
              fetchDataPromises.push( new Promise(function (resolve, reject){ let output = thisObj.fetchData(thisObj, activeset); resolve(output); }));

            }
            // if the set isn't active (anymore)
          else
            {
              // make sure table is emptied
              thisObj.items[ thisObj.selectedSearchType +'_'+activeset ] = []
            }

          // now fire the search promises!

          Promise.all(fetchDataPromises)
            .then(data => {

              // give table for results the right properties, given the query
              var tableOptions = tableBuilder.getOptions(null, thisObj.keyword, thisObj.selectedSearchType, activeAdvancedSearchFieldsSet, activeset);

              thisObj.fields[searchType_ActiveSet] = tableOptions["fields"];
              var sortSettings = tableOptions["sortsettings"];
              thisObj.sortBy[searchType_ActiveSet] = sortSettings[0];
              thisObj.sortDesc[searchType_ActiveSet] = sortSettings[1];

              thisObj.resetAdvancedSearchFields();

              // restore the search fields as they were at the beginning of the search
              thisObj.advancedLemma = utils.coalesce([thisObj.keyword['anwLemma'], thisObj.keyword['duelMeLemma'], thisObj.keyword['celexLemma'], thisObj.keyword['diamantLemma'], thisObj.keyword['molexLemma']]);
              thisObj.advancedLemPos = thisObj.keyword['molexLemPos'];

              thisObj.advancedWordform = utils.coalesce([thisObj.keyword['celexWordform'], thisObj.keyword['molexWordform']]);
              thisObj.advancedWordformPos = thisObj.keyword['molexWordformPos'];

              thisObj.advancedDefinition = utils.coalesce([thisObj.keyword['anwDefinition'], thisObj.keyword['diamantDefinition']]);        
              thisObj.advancedSynDefinition = thisObj.keyword['diamantSynDefinition'];
              
              thisObj.advancedExample = thisObj.keyword['duelMeExample'];
              thisObj.advancedAttestation = thisObj.keyword['duelMeAttestation'];

              thisObj.advancedNumber = utils.coalesce([thisObj.keyword['celexNumber'], thisObj.keyword['duelMeNumber']]);
              thisObj.advancedGender = utils.coalesce([thisObj.keyword['celexGender'], thisObj.keyword['duelMeGender']]);

              thisObj.searching[activeset] = false;

            });
          
      
        } // end of for-loop

      } // enf of advanced search section



      else // EXPERT SEARCH
      {
        // in expert search, we fire only one search at the time (compare with simple search)
        var searchType = this.selectedSearchType;

        // set status: search has started
        //this.searching[searchType] = true;

        // hide error message from previous round, if any
        this.errorMsg = '';
        this.errorLocation = '';

        // give table for results the right properties, given the query
        var tableOptions = tableBuilder.getOptions(this.sparqlQuery, this.keyword, this.selectedSearchType, null, null);

        this.fields[searchType] = tableOptions["fields"];
        var sortSettings = tableOptions["sortsettings"];
        this.sortBy[searchType] = sortSettings[0];
        this.sortDesc[searchType] = sortSettings[1];

        // effectively start the search
        this.fetchData(this, null);
      }
      
    },

    /**
     * @return {Promise<any>}
     */
    fetchData: function(thisObject, activeset){

      let thisObj = thisObject;

      var searchType_ActiveSet    = thisObj.selectedSearchType + (activeset != null? '_'+activeset : '');

      // show searching is busy
      thisObj.searching[ searchType_ActiveSet ] = true;
      

      // choose endpoint, given the query
      var baseUrl = utils.coalesce( [thisObj.endpoint[activeset], thisObj.endpoint['default']] );
      var url = baseUrl;// + '?query=' + encodeURIComponent( this.getQuery(activeset) );

      
      // AXIOS documentation: https://github.com/axios/axios

      const params = new URLSearchParams();
      var queryToSend = this.getQuery(activeset); 

      // ############################
      console.log(queryToSend);
      // ############################

      if (queryToSend != '' && queryToSend != null)
      {
        params.append('query', queryToSend);

        // make sure we erase previous result 
        // otherwise, it may appear again if the current query fails
        thisObj.items[searchType_ActiveSet] = [];

        // instantiate a httpclient with a timeout
        const httpClient = this.axios.create();
        httpClient.defaults.timeout = 2 * 60 * 1000; // wait max [number of minutes]*[60 sec in a min][1000 millisec in a sec]

        return httpClient.post(url, params).then(response => {
              // get table data              

              // In advanced search we need to process the results before loading those in the GUI table
              if (thisObj.selectedSearchType == 'advanced_search')
                {
                  let data = parser.parseResults(thisObj.selectedSearchType, response);
                  
                  thisObj.show_debug_info(searchType_ActiveSet + " is finished (performed)")

                  // join data
                  thisObj.items[searchType_ActiveSet] = parser.buildResultWithRelevance(data);

                  // set status: search is finished
                  thisObj.searching[searchType_ActiveSet] = false;

                  return thisObj.items[searchType_ActiveSet];
                }

              // In simple and expert search, we load the results straight into the GUI table
              else
                {
                  thisObj.items[searchType_ActiveSet] = parser.parseResults(thisObj.selectedSearchType, response);
                  // set status: search is finished
                  thisObj.searching[searchType_ActiveSet] = false;
                }

              

              // If dealing with simple search, make sure we display an active set.
              // Because if the visible results of a previous search were from a NOW inactive set,
              // this view will not be updated, even though we got fresh results from an active set...
              // that's why explicitly activating an active set is necessary for the results view to be refreshed/
              if (thisObj.selectedSearchType == 'simple_search')
              {
                // Action is only needed if none of the active sets has focus
                if ( !thisObj.simpleActiveSets.includes(thisObj.simpleActiveTab) )
                  thisObj.simpleActiveTab = thisObj.simpleActiveSets[0];
              }
                

        })
        .catch(error => {

            // when an error occured:
            // show that searching is over, otherwise the user will wait to no avail...
            thisObj.searching[searchType_ActiveSet] = false;

            thisObj.errorLocation = "Fout opgetreden in modus: " + searchType_ActiveSet;

            try {
              thisObj.errorMsg = error["response"]["data"];
            }
            catch(err) {
              // the server request failed somehow?
            }

            // we need output anyhow
            return thisObj.items[searchType_ActiveSet];
        });
      }

      // is search is CANCELED, remove progress indicator etc.
      else {

        // Advanced search
        if (thisObj.selectedSearchType == 'advanced_search')
          {
            thisObj.show_debug_info(searchType_ActiveSet + " is finished (canceled)");

            
            thisObj.searching[searchType_ActiveSet] = false;
            thisObj.items[searchType_ActiveSet] = [];

            // we need output anyhow
            return thisObj.items[searchType_ActiveSet];

          }
        // Simple and expert search
        else
          {
            thisObj.searching[ searchType_ActiveSet ]
            thisObj.items[searchType_ActiveSet] = [];
          }
      }
      
    },    


    
    

    getQuery: function (activeset){  
      
      // get the right SparQL query, given the chosen one

      // === SIMPLE SEARCH ===

      // ANW SEARCH

      if (this.selectedSearchType == 'simple_search' && activeset == 'anw')      
        return simpleQueryBuilder.buildAnwQuery(this.searchQuery);      

      // CELEX SEARCH

      if (this.selectedSearchType == 'simple_search' && activeset == 'celex')      
        return simpleQueryBuilder.buildCelexQuery(this.searchQuery);           

      // DUELME SEARCH

      if (this.selectedSearchType == 'simple_search' && activeset == 'duelme')      
        return simpleQueryBuilder.buildDuelMeQuery(this.searchQuery);      

      // MOLEX SEARCH

      if (this.selectedSearchType == 'simple_search' && activeset == 'molex')      
        return simpleQueryBuilder.buildMolexQuery(this.searchQuery);



      // === ADVANCED SEARCH ===

      // ANW SEARCH

      if (this.selectedSearchType == 'advanced_search' && activeset == 'definition')      
        return complexQueryBuilder.buildAnwQuery(this.advancedLemma, this.advancedDefinition);      

      // CELEX-MOLEX SEARCH

      if (this.selectedSearchType == 'advanced_search' && activeset == 'paradigm')      
        return complexQueryBuilder.buildCelexMolexQuery(this.paradigmLimit, this.advancedLemma, this.advancedWordform, this.advancedLemPos, this.advancedWordformPos, this.advancedNumber, this.advancedGender, this.advancedActiveSets);           

      // DUELME SEARCH

      if (this.selectedSearchType == 'advanced_search' && activeset == 'attestations')      
        return complexQueryBuilder.buildDuelMeQuery(this.advancedLemma, this.advancedExample, this.advancedAttestation, this.advancedNumber, this.advancedGender);      

      // DUELME MWE SEARCH

      if (this.selectedSearchType == 'advanced_search' && activeset == 'mwe')      
        return complexQueryBuilder.buildDuelMeMweQuery(this.advancedLemma, this.advancedLemPos);



      // === EXPERT SEARCH ===

      if (this.selectedSearchType == 'expert_search')   
      {
        // this one is easy: the user has typed his/her own query
        return this.sparqlQuery;
      }

    }
    
  }
}
</script>

<style lang="scss">
@import './css/style.css';
</style>



// WEBPACK FOOTER //
// src/App.vue